export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-en.a3e516ef.svg";